import React from "react";
import AnnouncementList from "../components/announcements/List";

function Landingslides() {
  return (
    <AnnouncementList />   
    );
}

export default Landingslides;
